import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Label = styled.label`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.black};
	margin-bottom: 4px;
`;

export const TagsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	align-items: center;
	min-height: 32px;
`;

export const AddTagButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 6px 14px;
	border-radius: 16px;
	border: 1px solid ${({ theme }) => theme.colors.lightGrey3};
	background: transparent;
	color: ${({ theme }) => theme.colors.lightGrey3};
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		border-color: ${({ theme }) => theme.colors.whitePearl};
		color: ${({ theme }) => theme.colors.whitePearl};
		background: ${({ theme }) => theme.colors.lightGrey3}15;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
		&:hover {
			border-color: ${({ theme }) => theme.colors.lightGrey3};
			color: ${({ theme }) => theme.colors.lightGrey3};
			background: transparent;
		}
	}
`;

export const EmptyText = styled.span`
	color: ${({ theme }) => theme.colors.lightGrey3};
	font-size: 14px;
	font-style: italic;
	opacity: 0.8;
`;

// Tag Chip styles
export const TagChipContainer = styled.div<{ $color?: string }>`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px;
	border-radius: 16px;
	background-color: ${({ $color }) => $color || '#E0E0E0'};
	font-size: 14px;
	font-weight: 500;
	color: #333;
	max-width: fit-content;
`;

export const TagContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const TagName = styled.span`
	font-size: 14px;
	font-weight: 500;
	line-height: 1;
`;

export const TagDescription = styled.span`
	font-size: 11px;
	font-weight: 400;
	opacity: 0.8;
	line-height: 1;
`;

export const RemoveButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background: none;
	border: none;
	cursor: pointer;
	padding: 0;
	width: 16px;
	height: 16px;
	color: #666;
	transition: color 0.2s;

	&:hover {
		color: #333;
	}

	svg {
		width: 12px;
		height: 12px;
	}
`;

// Inline selector styles
export const InlineSelectorContainer = styled.div`
	margin-top: 16px;
	border: 1px solid ${({ theme }) => theme.colors.lightGrey3};
	border-radius: 8px;
	padding: 16px;
	background-color: #f9f9f9;
`;

export const SelectorHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
`;

export const SelectorTitle = styled.h3`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};
	margin: 0;
`;

export const CloseButton = styled.button`
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.lightGrey3};
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		color: ${({ theme }) => theme.colors.black};
	}
`;

export const SearchContainer = styled.div`
	position: relative;
	margin-bottom: 12px;
`;

export const SearchIcon = styled.div`
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	color: ${({ theme }) => theme.colors.lightGrey3};
	pointer-events: none;
`;

export const SearchInput = styled.input`
	width: 100%;
	padding: 10px 12px 10px 40px;
	border: 1px solid ${({ theme }) => theme.colors.lightGrey3};
	border-radius: 8px;
	font-size: 14px;
	outline: none;

	&:focus {
		border-color: ${({ theme }) => theme.colors.whitePearl};
	}
`;

export const TagsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	max-height: 300px;
	overflow-y: auto;
	margin-bottom: 12px;
`;

export const TagItem = styled.div<{ $selected?: boolean }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px;
	border: 1px solid ${({ $selected, theme }) => ($selected ? theme.colors.whitePearl : theme.colors.lightGrey3)};
	border-radius: 8px;
	background-color: ${({ $selected }) => ($selected ? '#f0f7ff' : '#fff')};
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		border-color: ${({ theme }) => theme.colors.whitePearl};
		background-color: #f0f7ff;
	}
`;

export const TagColorPreview = styled.div<{ $color: string }>`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background-color: ${({ $color }) => $color};
	flex-shrink: 0;
`;

export const TagInfo = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const TagItemName = styled.span`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.black};
`;

export const TagItemDescription = styled.span`
	font-size: 12px;
	color: ${({ theme }) => theme.colors.lightGrey3};
`;

export const EmptyStateInline = styled.div`
	text-align: center;
	padding: 24px;
	color: ${({ theme }) => theme.colors.lightGrey3};
	font-size: 14px;
`;

export const CreateNewButton = styled.button`
	width: 100%;
	padding: 10px;
	border: 1px dashed ${({ theme }) => theme.colors.lightGrey3};
	border-radius: 8px;
	background: transparent;
	color: ${({ theme }) => theme.colors.lightGrey3};
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		border-color: ${({ theme }) => theme.colors.whitePearl};
		color: ${({ theme }) => theme.colors.whitePearl};
		background: ${({ theme }) => theme.colors.lightGrey3}15;
	}
`;

// Create form styles
export const CreateFormContainer = styled.div`
	margin-top: 12px;
	padding: 16px;
	border: 1px solid ${({ theme }) => theme.colors.lightGrey3};
	border-radius: 8px;
	background-color: #fff;
`;

export const FormField = styled.div`
	margin-bottom: 16px;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const FormLabel = styled.label`
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.black};
	margin-bottom: 6px;
`;

export const Input = styled.input`
	width: 100%;
	padding: 10px 12px;
	border: 1px solid ${({ theme }) => theme.colors.lightGrey3};
	border-radius: 8px;
	font-size: 14px;
	outline: none;

	&:focus {
		border-color: ${({ theme }) => theme.colors.whitePearl};
	}
`;

export const TextArea = styled.textarea`
	width: 100%;
	padding: 10px 12px;
	border: 1px solid ${({ theme }) => theme.colors.lightGrey3};
	border-radius: 8px;
	font-size: 14px;
	min-height: 80px;
	resize: vertical;
	outline: none;

	&:focus {
		border-color: ${({ theme }) => theme.colors.whitePearl};
	}
`;

export const ColorPickerWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const ColorInput = styled.input`
	width: 60px;
	height: 40px;
	border: 1px solid ${({ theme }) => theme.colors.lightGrey3};
	border-radius: 8px;
	cursor: pointer;
`;

export const ColorPreview = styled.div<{ $color: string }>`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	background-color: ${({ $color }) => $color};
	border: 1px solid ${({ theme }) => theme.colors.lightGrey3};
`;

export const FormActions = styled.div`
	display: flex;
	gap: 8px;
	margin-top: 16px;
`;

export const FormButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
	flex: 1;
	padding: 10px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	border: ${({ $variant }) => ($variant === 'secondary' ? '1px solid #e0e0e0' : 'none')};
	background: ${({ $variant }) => ($variant === 'secondary' ? 'transparent' : '#222')};
	color: ${({ $variant }) => ($variant === 'secondary' ? '#222' : '#fff')};

	&:hover {
		opacity: 0.9;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;
